module.exports = __webpack_public_path__ + "ui-static/img/hooks-no-items_light.b9dc4007.svg";